<template>
    <div class="col-12">
        <h4 class="header-title m-t-0">
            <i class="fas fa-globe mr-1"/>
            {{ $t("CarrierAreaList.carrierAreas") }}
        </h4>
        <hr/>
        <v-client-table :data="carrier.areas" :columns="table.columns" :options="table.options">
            <button @click="showCarrierAreaModal()" class="btn btn-primary pull-right" slot="afterLimit">
                <i class="fa fa-plus-circle mr-1"/>
                {{ $t("CarrierAreaList.addCarrierArea") }}
            </button>
            <router-link :to="`/billing/carrier-area/${props.row.id}`" class="font-bold" slot-scope="props" slot="name">
                {{ props.row.name }}
            </router-link>
            <span slot-scope="props" slot="destinations">
                <span v-if="!props.row.destinations.length">
                    {{ $t("CarrierAreaList.noAssociatedDestinations") }}
                </span>
                <span v-else>
                    <router-link v-for="destination in props.row.destinations" :to="`/billing/carrier-destination/${destination.id}`"
                                 :key="destination.id" v-tooltip="destination.country.name" class="ml-1">
                        <img alt="flag" width="30" :src="getDiceBaseUrl() + destination.country.flagURL" class="shadow"/>
                    </router-link>
                </span>
            </span>
            <div class="text-center" slot="actions" slot-scope="props">
                <router-link v-tooltip="$t('CarrierAreaList.see')" :to="`/billing/carrier-area/${props.row.id}`" class="btn btn-xs btn-info mr-1">
                    <i class="fa fa-eye"/>
                </router-link>
                <button v-tooltip="$t('CarrierAreaList.edit')" @click="showCarrierAreaModal(props.row)" class="btn btn-warning btn-xs mr-1">
                    <i class="fa fa-edit"/>
                </button>
                <CarrierAreaDeleteButton v-tooltip="$t('CarrierAreaList.delete')" @deleteCarrierArea="deleteCarrierArea" :carrier-area="props.row"/>
            </div>
            <div v-if="destinationsWithoutArea.length" slot="afterTable">
                <span class="font-bold">{{ $t('CarrierAreaList.destinationsWithoutArea') }}</span>
                (<span class="font-italic">{{ $t('CarrierAreaList.clickToEdit') }}</span>):
                <img v-for="destination in destinationsWithoutArea" :key="destination.id"
                     @click="showCarrierDestinationModal(destination)" v-tooltip="destination.country.name"
                     :src="destination.country.flagURL" alt="flag" width="30" class="editable-flag shadow ml-1"/>
            </div>
        </v-client-table>
        <CarrierAreaFormModal @addCarrierArea="addCarrierArea" @editCarrierArea="editCarrierArea" :carrier="carrier" ref="CarrierAreaFormModal"/>
        <CarrierDestinationFormModal @editCarrierDestination="editCarrierDestination" @editCarrierArea="editCarrierArea"
                                     ref="CarrierDestinationFormModal" :carrier="carrier"/>
    </div>
</template>

<script>
import CarrierAreaFormModal from "../../../../shared/Billing/CarrierArea/CarrierAreaFormModal";
import CarrierAreaDeleteButton from "./CarrierAreaDeleteButton";
import CarrierDestinationFormModal from "../../../../shared/Billing/CarrierDestination/CarrierDestinationFormModal";
import {permissiveFilter} from "../../../../../helpers/VueTable";
export default {
    name: "CarrierAreaList",
    components: {CarrierDestinationFormModal, CarrierAreaDeleteButton, CarrierAreaFormModal},
    props: {
        carrier: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            table: {
                columns: ["name", "destinations", "actions"],
                options: {
                    perPage: 10,
                    sortable: ["name"],
                    headings: {
                        name: this.$t("CarrierAreaList.name"),
                        destinations: this.$t("CarrierAreaList.associatedDestinations"),
                        actions: this.$t("CarrierAreaList.actions"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                    },
                },
            },
        };
    },
    computed: {
        destinationsWithoutArea() {
            return this.carrier.destinations.filter(d => d.area.id === undefined);
        },
    },
    methods: {
        showCarrierAreaModal(carrierArea = null) {
            this.$refs.CarrierAreaFormModal.show(carrierArea);
        },
        showCarrierDestinationModal(carrierDestination) {
            this.$refs.CarrierDestinationFormModal.show(carrierDestination);
        },
        addCarrierArea(carrierArea) {
            this.$emit("addCarrierArea", carrierArea);
        },
        editCarrierArea(newCarrierArea) {
            this.$emit("editCarrierArea", newCarrierArea);
        },
        editCarrierDestination(newCarrierDestination) {
            this.$emit("editCarrierDestination", newCarrierDestination);
        },
        deleteCarrierArea(carrierArea) {
            this.$emit("deleteCarrierArea", carrierArea);
        },
        getDiceBaseUrl() {
            return this.$diceAPI.getBaseUrl();
        },
    },
};
</script>

<style scoped>
    .editable-flag {
        cursor: pointer;
    }
</style>